// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import XngZone from "@west/App/Components/Common/XngZone";
import { StyledBox } from "@west/XDL/Utilities";
import React, { FC } from "react";

enum fields {
    borderRadius = "borderRadius",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.borderRadius]: number;
    };
}

export interface StyledBoxStyles {
    container?: InjectableCss;
}

export const styledBoxStyles: StyledBoxStyles = {};

const styles = styledBoxStyles;
export const StyledBoxWidget: FC<OwnProps> = ({ id, fields: { borderRadius } }) => {
    return (
        <StyledBox {...styles.container} borderRadius={borderRadius}>
            <XngZone zoneName="Content0" contentId={id} hint="richContent" />
        </StyledBox>
    );
};

const widgetModule: WidgetModule = {
    component: StyledBoxWidget,
    definition: {
        group: "Cart",
        displayName: "Styled Box",
        fieldDefinitions: [
            {
                name: fields.borderRadius,
                editorTemplate: "IntegerField",
                defaultValue: 0,
                fieldType: "General",
                min: 0,
            },
        ],
    },
};

export default widgetModule;
